import { useId } from 'react'
import { useTranslation } from 'react-i18next'
import { InfoIcon } from 'lucide-react'
import { Button } from 'ui/button'
import {
  Drawer,
  DrawerClose,
  DrawerContent,
  DrawerDescription,
  DrawerFooter,
  DrawerHeader,
  DrawerTitle,
  DrawerTrigger,
} from 'ui/drawer'
import { Label } from 'ui/label'
import { Switch } from 'ui/switch'

import { useSettingsStore } from '~/stores/settings'

type ScopeSnoozeToFrontLanguageControlProps = {
  className?: string
}

export const ScopeSnoozeToFrontLanguageControl = ({ className }: ScopeSnoozeToFrontLanguageControlProps) => {
  const scopeSwitchId = useId()
  const { t } = useTranslation()
  const patchSettings = useSettingsStore(state => state.patchSettings)
  const scopeSnoozeToFrontLanguage = useSettingsStore(state => state.scopeSnoozeToFrontLanguage)

  return (
    <div className={className}>
      <div className="flex w-full flex-wrap items-center gap-2">
        <Switch
          checked={scopeSnoozeToFrontLanguage}
          id={scopeSwitchId}
          onCheckedChange={isChecked => patchSettings({ scopeSnoozeToFrontLanguage: isChecked })}
        />
        <Label className="min-w-0" htmlFor={scopeSwitchId}>
          {t('Scope snooze to front')}
        </Label>
        <Drawer>
          <DrawerTrigger
            render={
              <Button aria-label={t('Scope snooze to front info')} className="shrink-0" size="icon" variant="ghost" />
            }
          >
            <InfoIcon className="size-4 stroke-primary" />
          </DrawerTrigger>
          <DrawerContent>
            <div className="mx-auto w-full max-w-sm">
              <DrawerHeader>
                <DrawerTitle>{t('Scope snooze to front')}</DrawerTitle>
                <DrawerDescription>
                  {t(
                    'When enabled, snoozing only hides the card for the current front language; when disabled, it applies to both',
                  )}
                </DrawerDescription>
              </DrawerHeader>
              <DrawerFooter className="p-4">
                <DrawerClose render={<Button variant="outline" />}>{t('Close')}</DrawerClose>
              </DrawerFooter>
            </div>
          </DrawerContent>
        </Drawer>
      </div>
    </div>
  )
}
